import type { ReactNode } from 'react'
import Card from '../ui/Card'

interface WidgetShellProps {
  title: string
  description?: string
  action?: ReactNode
  children: ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

export default function WidgetShell({
  title,
  description,
  action,
  children,
  className = '',
  padding = 'none',
}: WidgetShellProps) {
  return (
    <Card padding={padding} className={`overflow-hidden ${className}`}>
      <div className="flex items-start justify-between gap-4 border-b border-white/10 px-4 py-3.5 md:px-5">
        <div className="min-w-0">
          <h2 className="truncate text-sm font-semibold text-gray-100">{title}</h2>
          {description && <p className="mt-1 text-xs leading-relaxed text-gray-500">{description}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      {children}
    </Card>
  )
}
